import { teacherQueries } from '../../view/teachers/list/graphql'

/**
 * The teacher pickers — the conversation UI's new-conversation recipient and requester change control, and the
 * school invite composer — search registered teachers the same way. Tenant and `type: Teacher` are enforced
 * server-side (TeacherRepository.filterWithTenant), so only the name search belongs in this filter.
 *
 * Deliberately untyped as `DataLoadOptions` — that type omits the `query` field its own runtime
 * reads via `get(dataLoadOptions, 'query')` (libs/webui/input/src/Select/index.tsx:71), so
 * annotating this `const` would fail the same excess-property check an inline object literal does.
 */
export const teacherDataLoadOptions = {
  query: teacherQueries.allConfig.query,
  resultFieldName: 'allTeacher',
  filter: ({ input }) => ({ 'profile.name': { $regex: input, $options: 'i' } }),
}
